
import React from 'react';
import { ArrowDown } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PricingFooter: React.FC = () => {
  return (
    <>
      <div className="mt-6 text-center">
        <div className="inline-flex items-center bg-white px-4 py-2 rounded-lg border border-yellow-300 shadow-sm text-sm">
          <ArrowDown className="h-4 w-4 text-accent mr-2" />
          <span className="text-darkgray font-opensans">Du kan uppgradera eller nergradera ditt abonnemang när som helst</span>
        </div>
      </div>
      
      <div className="mt-14 text-center">
        <p className="text-darkgray/80 mb-4 text-lg font-opensans">Osäker på vilken plan som passar dig bäst?</p>
        <Button 
          variant="outline" 
          className="bg-transparent border-2 border-darkgray text-darkgray hover:bg-darkgray hover:text-white font-montserrat px-8 py-6 text-lg rounded-xl"
        >
          Boka en gratis konsultation
        </Button>
      </div>
      
      <div className="mt-6 text-center">
        <p className="text-xs text-darkgray/60 font-opensans">* Besparingar baserade på årlig betalning jämfört med månadsvis.</p>
      </div>
    </>
  );
};

export default PricingFooter;
